<template>
  <div>
    <auth-title label="Vielen Dank für Ihre Registrierung" />
    <auth-text>
      Bitte prüfen Sie Ihre E-Mails und klicken Sie auf den Bestätigungslink in der E-Mail, um die Registrierung abzuschließen und die Bestellung fortzusetzen.
    </auth-text>
  </div>
</template>

<script>
import AuthText from "@/components/plenigo-auth/components/auth-text";
import AuthTitle from "@/components/plenigo-auth/components/auth-title";

export default {
  components: { AuthText, AuthTitle },
  props: {
    state: Object
  }
};
</script>
